import { ViewConfig } from '@helo/cms'
import { Navigate, RouteObject } from 'react-router-dom'

import { iconRegistry } from '../components/Icons/icon-registry'
import { Role } from '../config/roles'
import { SavedViewsPage } from '../pages/SavedViewsPage'
import { SettingsPage } from '../pages/SettingsPage'
import { UserGuidePage } from '../pages/UserGuidePage'
import { AuditAdminPage } from '../pages/admin/AuditAdminPage/AuditAdminPage'
import { DBSubgraphConfigsAdminPage } from '../pages/admin/DBSubgraphConfigsAdminPage/DBSubgraphConfigsAdminPage'
import { DBSubgraphsAdminPage } from '../pages/admin/DBSubgraphsAdminPage/DBSubgraphsAdminPage'
import { DeploymentDetailsAdminPage } from '../pages/admin/DeploymentDetailsAdminPage/DeploymentDetailsAdminPage'
import { DeploymentsAdminPage } from '../pages/admin/DeploymentsAdminPage/DeploymentsAdminPage'
import { GatewaySupergraphAdminPage } from '../pages/admin/GatewaySupergraphAdminPage/GatewaySupergraphAdminPage'
import { OrganizationsAdminPage } from '../pages/admin/OrganizationsAdminPage/OrganizationsAdminPage'
import { SmrtArtifactsAdminPage } from '../pages/admin/SmrtArtifactsAdminPage/SmrtArtifactsAdminPage'
import { UsersAdminPage } from '../pages/admin/UsersAdminPage/UsersAdminPage'

export type RouteConfig = RouteObject & {
  /**
   * Human readable name for a route
   */
  label?: string
  /**
   * Unique identifier for a route
   */
  routeId: string

  /**
   * Iconography for a route
   */
  routeIconName?: keyof typeof iconRegistry
  /**ID of the cms content page... not a fan of the name. */
  screen?: string
  /**
   * Set if the page is defined by CMS
   */
  viewConfig?: ViewConfig
  roles?: Role[]
}

export const staticRoutes: RouteConfig[] = [
  {
    label: 'Saved Views',
    routeId: 'saved-views',
    path: '/saved-views',
    element: <SavedViewsPage />,
  },
  {
    label: 'Settings',
    routeId: 'settings',
    routeIconName: 'GearIcon',
    path: '/settings',
    element: <SettingsPage />,
  },
  {
    label: 'Admin',
    routeId: 'admin',
    path: '/admin',
    roles: ['Helo-Internal'],
    element: <Navigate to="/admin/customer-data-api-status" replace />,
  },
  {
    label: 'Customer Data API Status',
    path: '/admin/customer-data-api-status',
    routeId: 'customer-data-api-status-admin',
    roles: ['Helo-Internal'],
    element: <DBSubgraphsAdminPage />,
  },
  {
    label: 'Customer Data API Config',
    path: '/admin/customer-data-api-config',
    routeId: 'customer-data-api-config-admin',
    roles: ['Helo-Internal'],
    element: <DBSubgraphConfigsAdminPage />,
  },
  {
    label: 'GraphQL Gateway',
    path: '/admin/graphql-gateway',
    routeId: 'graphql-gateway-admin',
    roles: ['Helo-Internal'],
    element: <GatewaySupergraphAdminPage />,
  },
  {
    label: 'Deployments',
    path: '/admin/deployments',
    routeId: 'deployments-admin',
    roles: ['Helo-Internal'],
    element: <DeploymentsAdminPage />,
  },
  {
    path: '/admin/deployments/:id',
    label: 'Deployment Details',
    routeId: 'deployment-details-admin',
    roles: ['Helo-Internal'],
    element: <DeploymentDetailsAdminPage />,
  },
  {
    label: 'SMRT Artifacts',
    path: '/admin/smrt-artifacts',
    routeId: 'smrt-artifacts-admin',
    roles: ['Helo-Internal'],
    element: <SmrtArtifactsAdminPage />,
  },
  {
    label: 'Audit',
    path: '/admin/audit',
    routeId: 'audit-admin',
    roles: ['Helo-Internal'],
    element: <AuditAdminPage />,
  },
  {
    label: 'Organizations',
    path: '/admin/organizations',
    routeId: 'organizations-admin',
    roles: ['Helo-Internal'],
    element: <OrganizationsAdminPage />,
  },
  {
    label: 'Users',
    path: '/admin/users',
    routeId: 'users-admin',
    roles: ['Helo-Internal'],
    element: <UsersAdminPage />,
  },
  {
    label: 'User Guide',
    routeId: 'user-guide',
    routeIconName: 'InfoOutlineIcon',
    path: '/user-guide',
    element: <UserGuidePage />,
  },
]
